export class QConnection {
  constructor() {
    this.fSourceTile = null;
    this.fTargetTile = null;
    this.fValue = 0;
    this.fType = "";
  }

  InitConnection(sourceTile, targetTile, value, type) {
    this.fSourceTile = sourceTile;
    this.fTargetTile = targetTile;
    this.fValue = value;
    this.fType = type;
  }
}
